// page/ProductsPage.js
import React from 'react';

const ProductsPage = () => (
  <div className="p-4 lg:p-8 bg-white rounded-lg lg:rounded-xl border border-gray-200">
    <h2 className="text-lg lg:text-xl font-bold">Mahsulotlarim</h2>
    <p className="text-gray-600 mt-2">Bu yerda fermer mahsulotlari ro‘yxati bo‘ladi...</p>
    {/* Add your product list or logic here */}
  </div>
);

export default ProductsPage; // Ensure default export